// Loads PayTrace Protect.js on demand with retries. It used to be a static
// <script> tag in index.html: a one-off network/CDN failure while the page
// loaded left window.PTPayment undefined for the whole session, and the
// payment popup then spun forever with no recovery path.
// Default to production: a missing REACT_APP_PROTECT_JS_URL must not silently
// point live payments at the sandbox, which serves its hosted payment fields
// with headers that stop the card form from initialising. Dev sets the sandbox
// URL explicitly in its own .env.
const PROTECT_JS_URL =
  process.env.REACT_APP_PROTECT_JS_URL ||
  "https://protect.paytrace.com/js/protect.min.js";

const MAX_ATTEMPTS = 3;

let loadPromise = null;

export function loadProtectJs() {
  if (window.PTPayment) return Promise.resolve();
  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      attempt(1, resolve, reject);
    }).catch((error) => {
      // Allow a later retry (e.g. the Try Again button) to start fresh
      loadPromise = null;
      throw error;
    });
  }
  return loadPromise;
}

function attempt(attemptNo, resolve, reject) {
  const script = document.createElement("script");
  script.src = PROTECT_JS_URL;
  script.async = true;
  script.onload = () => resolve();
  script.onerror = () => {
    script.remove();
    if (attemptNo < MAX_ATTEMPTS) {
      setTimeout(() => attempt(attemptNo + 1, resolve, reject), attemptNo * 1000);
    } else {
      reject(new Error(`Protect.js failed to load after ${MAX_ATTEMPTS} attempts`));
    }
  };
  document.head.appendChild(script);
}
